import { homeContent } from "../data/mockHome";

export function ServicesPage() {
  return (
    <div className="bg-slate-950 py-24">
      <div className="mx-auto max-w-6xl px-6">
        <header className="max-w-3xl">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-emerald-300">
            Services
          </p>
          <h1 className="mt-4 text-4xl font-semibold text-white">
            AVUX aligns UX, AI, and operations to remove friction and increase measurable impact.
          </h1>
        </header>
        <div className="mt-16 grid gap-8 lg:grid-cols-2">
          {homeContent.pillars.map((pillar) => (
            <article
              key={pillar.title}
              className="rounded-3xl border border-white/10 bg-white/5 p-8 text-slate-100"
            >
              <h2 className="text-2xl font-semibold text-white">{pillar.title}</h2>
              <p className="mt-3 text-sm text-slate-300">{pillar.description}</p>
              <p className="mt-6 text-xs font-semibold uppercase tracking-[0.3em] text-emerald-300">
                Business outcomes
              </p>
              <p className="mt-3 text-sm text-slate-200">
                We drive faster delivery, higher adoption, and measurable performance by connecting UX to operational metrics.
              </p>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
